module.exports = __webpack_public_path__ + "img/google_play.ca6ea62a.png";